import { render, staticRenderFns } from "./SimilarQuery.vue?vue&type=template&id=d9fff38a&scoped=true"
import script from "./SimilarQuery.vue?vue&type=script&lang=js"
export * from "./SimilarQuery.vue?vue&type=script&lang=js"
import style0 from "./SimilarQuery.vue?vue&type=style&index=0&id=d9fff38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fff38a",
  null
  
)

export default component.exports